<template>
  <div>
    <div v-if="$route.path.indexOf('_editor') === -1 && $route.path.indexOf('_detail') === -1 ">

      <el-row :gutter="20">
          <el-col :span="4">
            <el-input placeholder="设备名称" v-model="params.device_name"></el-input>
          </el-col>
          <el-col :span="4">
          <el-input placeholder="设备id" v-model="params.device_id">
            <el-button slot="append" icon="el-icon-search" @click="numberSearch"></el-button>
          </el-input>
        </el-col>
        <el-col :span="15">
          <category-select  distributors @update="storeSearch" :shopIdDefault="distributor_id"></category-select>
        </el-col>
      </el-row>
      <el-table :data="list" @selection-change="handleSelectionChange" :height="wheight-140" v-loading="loading">
        <el-table-column type="selection" align="center" label="全选"></el-table-column>
        <el-table-column prop="distributor_name" label="店铺名称"></el-table-column>
        <el-table-column prop="distributor_id" label="店铺ID"></el-table-column>
        <el-table-column prop="device_name" label="设备名称"></el-table-column>
        <el-table-column prop="device_id" label="设备ID"></el-table-column>
        <el-table-column prop="status" label="绑定状态" width="120">
          <template slot-scope="scope">
            <span v-if="scope.row.status==1">已绑定</span>
            <span v-else>未绑定</span>
          </template>
        </el-table-column>
        <el-table-column prop="create_at" label="绑定时间">
          <template slot-scope="scope">
            <span>{{ scope.row.update_at | datetime('yyyy-MM-dd hh:mm:ss') }}</span>
          </template>
        </el-table-column>
        <el-table-column label="操作" min-width="100">
          <template slot-scope="scope">
            <el-button v-if="scope.row.status==1" type="text" @click="viweUnbindBox(scope.row)">解绑</el-button>
          </template>
        </el-table-column>
      </el-table>
      <el-dialog
        title="提示"
        :visible.sync="unbindVisible"
        width="30%"
        :before-close="handleClose">
        <span>是否确认解绑？</span>
        <span slot="footer" class="dialog-footer">
          <el-button @click="unbindVisible = false">取 消</el-button>
          <el-button type="primary" @click="unbind(row)">确 定</el-button>
        </span>
      </el-dialog>
      <div v-if="total_count > params.pageSize" class="content-padded content-center">
        <el-pagination
          background
          layout="prev, pager, next"
          @current-change="handleCurrentChange"
          :current-page.sync="params.page"
          :total="total_count" :page-size="params.pageSize">
        </el-pagination>
      </div>
    </div>
    <router-view></router-view>
    <DistributorSelect :store-visible="DistributorVisible"
                       :rel-data-ids="relDistributors"
                       :get-status="DistributorStatus"
                       @chooseStore="DistributorChooseAction"
                       @closeStoreDialog="closeDialogAction"></DistributorSelect>
  </div>
</template>
<script>
import {mapGetters} from 'vuex'
import {getPrintDeviceList, unbindPrintDevice} from '../../../api/marketing'
import categorySelect from '@/components/categorySelect'
import DistributorSelect from '@/components/function/distributorSelect'

export default {
  components: {
    categorySelect,
    DistributorSelect
  },
  props: {
    distributorId: {
      type: String,
      default: ''
    },
    isLoad: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      changeStatus: true,
      DistributorVisible: false,
      activeName: 'first',
      total_count: 0,
      dialogTitle: '',
      unbindVisible: false,
      loading: false,
      list: [],
      choose: [],
      params: {
        page: 1,
        pageSize: 20,
        device_id: '',
        distributor_id: '',
        device_name: '',
        status: ''
      },
      distributor_id: '',
      relDistributors: [],
      DistributorStatus: false,
      chooseCat: [],
      checkAll: false,  //全选的v-model值

    }
  },
  computed: {
    ...mapGetters([
      'wheight'
    ])
  },
  methods: {
    getDataId(e) {
      var id = e.target.dataset.id;
      if (e.target.checked == false) {
        var index = this.chooseCat.indexOf(id);
        this.chooseCat.splice(index, 1);
      } else {
        this.chooseCat.push(id);
      }
      console.log(id, this.chooseCat)
    },
    closeDialogAction() {
      this.DistributorStatus = false
      this.DistributorVisible = false
    },
    storeSearch(val, name = "") {
      if (name != "") {
        this.$parent.titile_label = name
      }
      val && val.shop_id
      this.params.distributor_id = val.shop_id
      this.distributor_id = val.shop_id
      this.params.page = 1
      this.getList()
    },
    DistributorChooseAction(data) {
      this.DistributorVisible = false
      this.DistributorStatus = false
      if (data === null || data.length <= 0) return
      this.relDistributors = data
    },
    //全选 反选
    clickCheckAll: function () {
      var _this = this;
      _this.chooseCat = [];
      _this.checkAll = !_this.checkAll;   //取反
      for (var i = 0; i < _this.categoryList.length; i++) {  //循环所有checkbox,添加选中状态
        var checkedData = _this.categoryList[i];
        checkedData.isChecked = _this.checkAll;
        _this.chooseCat.push(_this.categoryList[i]['category_id']);
      }
      if (_this.checkAll == false) {
        _this.chooseCat = [];
      }
      console.log(_this.checkAll, _this.chooseCat)
    },
    numberSearch(e) {
      this.params.page = 1
      this.getList()
    },
    handleCurrentChange(page_num) {
      this.params.page = page_num
      this.getList()
    },
    getList() {
      this.loading = true
      getPrintDeviceList(this.params).then(response => {
        console.log(this.distributor_id)
        if (response.data.data.list) {
          this.list = response.data.data.list
          this.total_count = response.data.data.total_count
        }
        this.loading = false
      }).catch(error=>{
        this.loading = false
        console.log(error);
      });
    },
    handleClose() {
      this.unbindVisible = false
    },
    viweUnbindBox(row) {
      // console.log(row)
      this.unbindVisible = true
      this.choose = row
    },
    unbind() {
      let choose = this.choose
      unbindPrintDevice(choose.distributor_id).then(response => {
        this.unbindVisible = false
        this.getList()
        this.$message({
          type: 'success',
          message: '解绑成功'
        })
      }).catch(error => {
        this.$message({
          type: 'error',
          message: '解绑失败'
        })
      })
    },
    handleSelectionChange(val) {
      let distributor_id = []
      for (let i in val) {
        distributor_id.push(val[i].distributor_id)
      }
      this.distributor_id = distributor_id
    },
    async getDistributorItemList() {
      let distributor = await this.getDefaultDistributor(this.params.distributor_id)
      if (!this.params.distributor_id && distributor) {
        this.params.distributor_id = distributor.distributor_id
      }
    }
  },
  mounted() {
    this.$nextTick(() => {
      if (this.isLoad) {
        if (!this.distributorId) {
          this.getDistributorItemList()
        } else {
          this.params.distributor_id = this.distributorId
          this.getDistributorItemList()
        }
      }
    })
    this.getList()
  }

}
</script>

<style lang="scss" scoped>

</style>



// WEBPACK FOOTER //
// distributorprintdevice.vue?4c7c7d16